import React, { PureComponent } from 'react'
import { connect } from 'react-redux'
import { withRouter } from 'react-router'
import { bindAll } from 'redux-act'

import defaultPage from '../hocs/defaultPage'
import RenderKatex from '../components/RenderKatex'
import Loader from '../components/Loader'
import { thunks } from '../ducks/viewShare'
import { buttons, actions as navigationActions } from '../ducks/navigation'

// Styled Components
import { ViewShareWrap } from './ViewShare.styles'

class ViewShare extends PureComponent {
    componentDidMount() {
        const { loadMath, match, nav } = this.props
        const { slug } = match.params

        nav.disableButton(buttons.save)
        nav.enableButton(buttons.remix)
        loadMath(slug)
    }

    componentDidUpdate() {
        const { loadFailed, history } = this.props
        if (loadFailed) history.push('/404')
    }

    render() {
        const { isLoadingCode, katexCode } = this.props

        return (
            <ViewShareWrap>
                {isLoadingCode ? (
                    <Loader />
                ) : (
                    <RenderKatex displayMode={true} renderErrors={true}>
                        {`$ ${katexCode} $`}
                    </RenderKatex>
                )}
            </ViewShareWrap>
        )
    }
}

const ViewShareComponent = connect(
    ({ viewShare }) => ({
        ...viewShare
    }),
    dispatch => ({
        loadMath: key => dispatch(thunks.loadMath(key)),
        nav: {
            ...bindAll(navigationActions, dispatch)
        }
    })
)(ViewShare)

export default {
    component: defaultPage(withRouter(ViewShareComponent)),
    path: '/v/:slug'
}



// WEBPACK FOOTER //
// ./src/pages/ViewShare.js